module.exports = __webpack_public_path__ + "img/icon-lego-product.cdb6db5d.svg";